import sortBy from 'lodash/sortBy';
import map from 'lodash/map';
import getAttributeLink from './get-attribute-link';

const getPhraseLabel = (phrases, id) => phrases[`${id}Title`];

export const selectBarChartData = (
  rankings,
  phrases,
  linkPath,
) => sortBy(
  map(rankings, (value, key) => ({
    label: getPhraseLabel(phrases, key),
    value,
    link: getAttributeLink(linkPath, key),
  })), 'value',
).reverse();

export default selectBarChartData;
